import React, { useRef, useState } from 'react';
import Webcam from "react-webcam";
import FullCalendar from '@fullcalendar/react';
import dayGridPlugin from '@fullcalendar/daygrid';
import interactionPlugin from '@fullcalendar/interaction';
import bootstrapPlugin from '@fullcalendar/bootstrap';
import { Link } from 'react-router-dom';
import timeGridPlugin from '@fullcalendar/timegrid';
import listPlugin from '@fullcalendar/list';
import './Attendance.css'


const Attendance = () => {
  const [image, setImage] = useState(null);
  const [location, setLocation] = useState(null);
  const [error, setError] = useState("");
  const [isCameraOpen, setIsCameraOpen] = useState(false);
  const webcamRef = useRef(null);
  const calendarRef = useRef(null);


  const handleDateClick = (info) => {
    alert(`Date clicked: ${info.dateStr}`);
    // You can add custom logic here
  };

  const captureImage = () => {
    if (webcamRef.current) {
      const imageSrc = webcamRef.current.getScreenshot();
      setImage(imageSrc);
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const { latitude, longitude } = position.coords;
          setLocation({ latitude, longitude });
          console.log({ latitude, longitude });
        },
        () => setError("Unable to fetch location")
      );
    }
  };

  const submitAttendance = async () => {
    if (!image || !location) {
      setError("Image or location missing");
      return;
    }

    const attendanceData = {
      image,
      latitude: location.latitude,
      longitude: location.longitude,
      date: new Date().toISOString(),
      userId: 123, // Replace with actual user ID
    };

    try {
      const response = await fetch("http://localhost:3000/attendance", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(attendanceData),
      });
      if (!response.ok) throw new Error("Failed to submit attendance");
      alert("Attendance submitted!");
    } catch (err) {
      setError(err.message);
    }
  };


  return (

    <>
    <div className="wrapper">
      <div className="content-page">
        <div className="content">
          {/* Start Content*/}
          <div className="container-fluid">
            {/* start page title */}
            <div className="row">
              <div className="col-12">
                <div className="page-title-box">
                  <div className="page-title-right">
                    <ol className="breadcrumb m-0">
                      <li className="breadcrumb-item"><Link to="/dashboard">Dashboard</Link></li>
                      <li className="breadcrumb-item active">Attendance</li>
                    </ol>
                  </div>
                  <h4 className="page-title">Attendance</h4>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-12">
                <div className="card">
                  <div className="card-body">
                    <div className="row">
                      <div className="col-lg-3">
                        <div className="d-grid">
                          <button className="btn btn-lg font-16 btn-danger" onClick={() => setIsCameraOpen(true)}>
                            <i className="mdi mdi-plus-circle-outline" /> Mark Attendance
                          </button>
                        </div>
                        <div id="external-events" className="mt-3">
                          {/* <p className="text-muted">Drag and drop your event or click in the calendar</p> */}
                          <div className="external-event bg-success-lighten text-success" data-class="bg-success"><i className="mdi mdi-checkbox-blank-circle me-2 vertical-middle" />New Theme Release</div>
                          <div className="external-event bg-info-lighten text-info" data-class="bg-info"><i className="mdi mdi-checkbox-blank-circle me-2 vertical-middle" />My Event</div>
                          <div className="external-event bg-warning-lighten text-warning" data-class="bg-warning"><i className="mdi mdi-checkbox-blank-circle me-2 vertical-middle" />Meet manager</div>
                          <div className="external-event bg-danger-lighten text-danger" data-class="bg-danger"><i className="mdi mdi-checkbox-blank-circle me-2 vertical-middle" />Create New theme</div>
                        </div>
                      </div> {/* end col*/}

                      <div class="col-lg-9">
                        <div class="mt-4 mt-lg-0">
                          <FullCalendar
                            ref={calendarRef}
                            plugins={[dayGridPlugin, interactionPlugin, bootstrapPlugin, timeGridPlugin, listPlugin]}
                            initialView="dayGridMonth"
                            dateClick={handleDateClick}
                            events={[
                              
                            ]}
                            headerToolbar={{
                              left: '',
                              center: 'title',
                              right: 'today prev,next',
                            }}
                            buttonText={{
                              prev: 'Prev',
                              next: 'Next',
                              today: 'Today'
                            }}
                          />
                        </div>
                      </div>
                    </div> {/* end row */}
                  </div> {/* end card body*/}
                </div> {/* end card */}
              </div>
              {/* end col-12 */}
            </div> {/* end row */}
          </div> {/* container */}
        </div> {/* content */}
      </div>
      </div>
      
      {isCameraOpen && (
        <div className="camera-overlay">
          <div className="camera-controls">
            {!image ? (
              <button className="btn btn-success" onClick={captureImage}>
                Capture
              </button>
            ) : (
              <button className="btn btn-success" onClick={submitAttendance}>
                Submit Attendance
              </button>
            )}
            <button
              className="btn btn-secondary ms-2"
              onClick={() => {
                setIsCameraOpen(false);
                setImage(null); // Reset image when closing the popup
              }}
            >
              Close
            </button>
          </div>
          {!image ? (
            <Webcam
              audio={false}
              ref={webcamRef}
              screenshotFormat="image/jpeg"
              className="camera-view"
            />
          ) : (
            <img src={image} alt="Captured" className="camera-view" />
          )}
        </div>
      )}
    </>

  );
};

export default Attendance;
